// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"06486210","69":"0f2483d9","169":"45d414de","410":"9c498805","439":"52cd4dae","443":"3c277243","457":"7e2feb29","630":"c2d5d6ec","716":"5a04867e"}[chunkId] + ".chunk.js";
};